import { render } from "./SezioneSottoProgetti.vue?vue&type=template&id=7522b39e&ts=true"
import script from "./SezioneSottoProgetti.vue?vue&type=script&lang=ts"
export * from "./SezioneSottoProgetti.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__